
import { Component, Vue } from "vue-property-decorator";
import { SMCases } from "@/store";
import { format } from "date-fns";
import { DEFAULT_TABLE_DATETIME_FORMAT } from "@/constants/datetime";
import { HIGH_RISK_ELIGIBILITY_RESULT } from "@/constants/assessment";
import { DEPENDANT_INSIDE_SERVICE_TYPE } from "@/constants/services";

@Component
export default class CandidateServicesTable extends Vue {
  get items() {
    return SMCases.casesCandidate;
  }

  formatDate(сreatedAt: string) {
    return format(new Date(сreatedAt), DEFAULT_TABLE_DATETIME_FORMAT);
  }

  async created() {
    await SMCases.getTableCases();
  }

  goToCase(id: number) {
    this.$router.push(`/cases/${id}/dashboard/${SMCases.tabId}`);
  }

  isError(finalDecision: string) {
    return !!(finalDecision === HIGH_RISK_ELIGIBILITY_RESULT);
  }

  getFinalDecision(finalDecision: string) {
    return finalDecision ? finalDecision : "—";
  }

  checkIfIsDependantCase(item) {
    const { case_template } = item;

    return [DEPENDANT_INSIDE_SERVICE_TYPE].includes(case_template.case_type);
  }

  getFullName(item) {
    const { main_applicant, dependant_applicant } = item;

    const isDependantCase = this.checkIfIsDependantCase(item);

    if (isDependantCase) {
      if (!dependant_applicant) return "";
    } else {
      if (!main_applicant) return "";
    }

    const { first_name, last_name } = isDependantCase ? dependant_applicant : main_applicant;

    return `${first_name} ${last_name}`;
  }
}
